import {Field, Formik, Form, FormikValues, FormikProps} from 'formik'
import {useEffect, useRef} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import { defaultDateForValidateOrders } from '../constants'
import { KTIcon } from '../../_metronic/helpers'

export const FilterByDate = ({onSubmit, filteredDate, setFilteredDate}) => {
  const intl = useIntl()
  const formikRef = useRef<FormikProps<FormikValues>>(null)
  const today = new Date()
  const yesterdayDate = () => {
    const yesterdayDate = new Date(today)
    yesterdayDate.setHours(today.getHours() - 24)
    if (yesterdayDate.getDay() === 6) {
      yesterdayDate.setHours(today.getHours() - 24 * 1)
    }
    if (yesterdayDate.getDay() === 0) {
      yesterdayDate.setHours(today.getHours() - 24 * 2)
    }
    return yesterdayDate.toISOString().split('T')[0]
  }
  const tomorrowDate = () => {
    const tomorrowDate = new Date(today)
    tomorrowDate.setHours(today.getHours() + 24)
    if (tomorrowDate.getDay() === 6) {
      tomorrowDate.setHours(today.getHours() + 24 * 2)
    }
    if (tomorrowDate.getDay() === 0) {
      tomorrowDate.setHours(today.getHours() + 24 * 1)
    }
    return tomorrowDate.toISOString().split('T')[0]
  }
  useEffect(() => {
    if (isNaN(filteredDate)) {
      filteredDate = defaultDateForValidateOrders
    }
    if (formikRef && formikRef.current) {
      formikRef.current.setFieldValue('selectedDate', filteredDate.toISOString().split('T')[0])
    }
  }, [filteredDate])
  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize={true}
      initialValues={{selectedDate: today.toISOString().split('T')[0]}}
      onSubmit={async (values) => {
        onSubmit(values)
      }}
    >
      {({setFieldValue}) => (
        <Form placeholder={undefined}>
          <Row className='justify-content-between justify-content-lg-start'>
            <Col xs='auto' lg='auto' className='mb-3 mb-lg-0 pe-0 pe-lg-2'>
              <Button
                type='button'
                variant='secondary'
                className='d-inline-block w-100 w-lg-auto px-2'
                onClick={() => {
                  setFieldValue('selectedDate', yesterdayDate())
                  setFilteredDate(new Date(yesterdayDate()))
                }}
              > 
                <KTIcon iconName='left' className='fs-2' />
              </Button>
            </Col>
            <Col xs='8' lg='auto' className='mb-3 mb-lg-0 order-1 order-lg-0 p-0'>
              <Field
                type='date'
                name='selectedDate'
                className='form-control w-100 w-lg-auto'
                style={{ color: "var(--bs-gray-600)"}}
                //value={filteredDate.toISOString().split('T')[0]}
                // onChange={(element) => {
                //   localStorage.removeItem('filteredDate')
                //   setFilteredDate(new Date(element.target.value))
                //   localStorage.setItem('filteredDate', element.target.value)
                // }}
              />
            </Col>
            <Col xs='auto' lg='auto' className='mb-3 mb-lg-0 order-1 order-lg-0 ps-0 ps-lg-2'>
              <Button
                type='button'
                variant='secondary'
                className='d-inline-block w-100 w-lg-auto px-2'
                onClick={() => {
                  setFieldValue('selectedDate', tomorrowDate())
                  setFilteredDate(new Date(tomorrowDate()))
                }}
              >
                <KTIcon iconName='right' className='fs-2' />
              </Button>
            </Col>
            <Col xs='12' lg='auto' className='p-lg-0 order-last order-lg-0'>
              <Button type='submit' className='d-inline-block w-100 w-lg-auto'>
                {intl.formatMessage({id: 'VALIDATE_ORDERS.FILTER'})}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}
